export default "__VITE_ASSET__B4rvj5RD__"